import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-content',
  templateUrl: './card-content.component.html',
  styleUrls: ['./card-content.component.scss']
})
export class CardContentComponent implements OnInit {
  constructor() {}

  // headとbodyの間のライン
  @Input() showSeparator = false;

  ngOnInit() {}
}
